// Apigee management token, minted by fai-apigee-wrapper-svc impersonating this
// fixed service account (the wrapper rejects any other sa_email):
// GET https://forgeaigateway.probestack.io/apigee-wrapper/token?sa_email=...
// (the ingress only routes /apigee-wrapper/* to the wrapper; /token at the host
// root is served by this frontend and returns HTML).
// Response: { access_token, token_type, expires_in, expiry_date, scope }.
export const APIGEE_SA_EMAIL = 'ps-migration-testing@gen-ai-poc-onboarding.iam.gserviceaccount.com';
const APIGEE_TOKEN_ENDPOINT = process.env.REACT_APP_APIGEE_TOKEN_URL || 'https://forgeaigateway.probestack.io/apigee-wrapper/token';
export const APIGEE_TOKEN_URL = `${APIGEE_TOKEN_ENDPOINT}?sa_email=${APIGEE_SA_EMAIL}`;

const org = value => `/organizations/${encodeURIComponent(value)}`;
export const APIGEE_ENDPOINTS = {
  ORGANIZATIONS: { LIST: '/organizations' },
  ENVIRONMENT: { LIST: value => `${org(value)}/environments` },
  APIS: { DETAILS: value => `${org(value)}/apis/details`,
    DEPLOY: (o, e, p, r) => `${org(o)}/environments/${encodeURIComponent(e)}/apis/${encodeURIComponent(p)}/revisions/${encodeURIComponent(r)}/deployments` },
  SHARED_FLOWS: { DETAILS: value => `${org(value)}/sharedflows/details`,
    DEPLOY: (o, e, sf, r) => `${org(o)}/environments/${encodeURIComponent(e)}/sharedflows/${encodeURIComponent(sf)}/revisions/${encodeURIComponent(r)}/deployments` },
};
